import React, { useRef } from "react";

import styles from "./popover.module.css";
import useOutsideAlerter from "../../utils/clickOutside";

const Popover = ({ content, onClose, bgColor = 'primary' }) => {
  const popoverRef = useRef(null);

  useOutsideAlerter(popoverRef, onClose);

  return (
    <div className={`${styles.popover} ${styles[bgColor]}`} ref={popoverRef}>
      <div className="popover-content">{content}</div>
    </div>
  );
};

export default Popover;
